import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import { isRouteErrorResponse, Link, useRouteError } from 'react-router'

import { Button } from '@/components/ui/button'
import NotFoundPage from '@/pages/404'

export const ErrorBoundary = () => {
  const error = useRouteError() as Error
  const notFound = isRouteErrorResponse(error) && error.status === 404

  useEffect(() => {
    if (!notFound) Sentry.captureException(error)
  }, [error, notFound])

  if (notFound) return <NotFoundPage />

  return (
    <div className="mx-auto flex min-h-[50vh] w-full max-w-md flex-col items-center justify-center gap-3 px-8 py-16 text-center">
      <p className="text-xs text-muted-foreground">Chyba aplikace</p>
      <h1 className="text-xl font-medium">Něco se pokazilo</h1>
      <p className="text-sm text-muted-foreground text-pretty">
        {error?.message || 'Stránku se nepodařilo zobrazit. Zkuste ji načíst znovu.'}
      </p>
      <div className="flex gap-2 pt-2">
        <Button variant="outline" onClick={() => window.location.reload()}>Načíst znovu</Button>
        <Button asChild><Link to="/">Na přehled</Link></Button>
      </div>
    </div>
  )
}
